import { Component, Injector, OnInit } from '@angular/core';
import { RuleDefinitionService } from 'tnx-admin-service/ruledefinition/services';
import { AutoCompleteControlSchema, ComponentContextService, CustomControlSchema, DataFormBase, Filter, FormControlBase, FormSchemaBase, genQueryFromFilters, PopupSize, QueryGroup, TableSchema, TextControlSchema, UpperCorrector } from 'tnx-shared';
import * as jsep from 'jsep';
enum EnumType {
    OPERATOR = 1,
    FUNCALL = 2
}
@Component({
    selector: 'ruledefinition-form',
    templateUrl: './ruledefinition-form.component.html',
    styleUrls: ['./ruledefinition-form.component.scss'],
    providers: [ComponentContextService],
})
export class RuleDefinitionFormComponent extends DataFormBase implements OnInit {
    ruleGeneratorModel = {
        showForm: false,
        popupSize: new PopupSize({ width: 1200, height: 750 }),
        filter: null,

        event: null,
        control: null,
        data: null,
        changeFunction: null,
        parentPath: null
    };

    operators = [
        { id: '==', ten: '==' },
        { id: '!=', ten: '!=' },
        { id: '>=', ten: '>=' },
        { id: '>', ten: '>' },
        { id: '<', ten: '<' },
        { id: '<=', ten: '<=' }
    ];
    controlValue = new AutoCompleteControlSchema({
        multiple: false,
        dataSource: [],
        disabled: false
    });
    dataSourceFields: any[] = [];
    query: any = new QueryGroup();
    control = new AutoCompleteControlSchema({
        multiple: false
    });
    mathOperators = [
        '+', '-', '*', '/', '^', '%'
    ];
    mathOperator2s = [
        '==', '!=', '>=', '>', '<', '<='
    ];
    constructor(
        protected _injector: Injector,
        private _ruleDefinitionService: RuleDefinitionService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._ruleDefinitionService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                label: 'Tên',
                fullLabel: 'Tên',
                field: 'title',
                required: true
            }),
            new TextControlSchema({
                label: 'Mã',
                fullLabel: 'Mã',
                field: 'code',
                required: true,
                correctors: [new UpperCorrector()],
                disabled: this.model.data.id != null
            }),
            new TableSchema({
                label: 'Danh sách tham số',
                fullLabel: 'Danh sách tham số',
                field: 'clientParams',
                mdWidth: 12,
                rowTemplate: [
                    new TextControlSchema({
                        label: 'Tên tham số',
                        fullLabel: 'Tên tham số',
                        field: 'name',
                        required: true
                    }),
                    new TextControlSchema({
                        label: 'Giá trị',
                        fullLabel: 'Giá trị mặc định',
                        placeholder: 'Ex: 1, "2", "2021-01-31T00:00:00Z"...',
                        field: 'value',
                        required: true
                    }),
                ]
            }),
            new TableSchema({
                label: 'Danh sách rule',
                fullLabel: 'Danh sách rule',
                field: 'clientRules',
                mdWidth: 12,
                rowTemplate: [
                    new CustomControlSchema({
                        label: 'Mệnh đề',
                        fullLabel: 'Mệnh đề logic',
                        // placeholder: 'Ex: v1 >= t1 AND v1 < 10',
                        field: 'expression',
                        required: true,
                        width: '50%'
                    }),
                    new TextControlSchema({
                        label: 'Giá trị',
                        fullLabel: 'Giá trị trả về nếu TRUE',
                        placeholder: 'Ex: true, 1, "OK"...',
                        field: 'output',
                        width: '20%',
                    }),
                    new TextControlSchema({
                        label: 'Thông báo',
                        fullLabel: 'Thông báo nếu FALSE',
                        placeholder: 'Ex: Giá trị {v1} không thỏa mãn lớn hơn hoặc bằng {t1}',
                        field: 'errorMessage',
                        width: '30%',
                    }),
                ]
            })
        ];
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        try {
            var params = JSON.parse(data.params);
            data.clientParams = [];
            for (var p of params) {
                data.clientParams.push({ name: p.Name, value: p.Expression });
            }

            var rules = JSON.parse(data.rules);
            data.clientRules = [];
            for (var r of rules) {
                data.clientRules.push({ expression: r.Expression, output: r.Properties ? r.Properties['output'] : null, errorMessage: r.ErrorMessage });
            }
        }
        catch { }
    }

    handleSettingRow(
        evt, control: FormControlBase, parentPath: string,
        clientRuleData: any, changeFunc: Function
    ) {
        this.dataSourceFields = [];
        this.ruleGeneratorModel.control = control;
        this.ruleGeneratorModel.parentPath = parentPath;
        this.ruleGeneratorModel.data = clientRuleData;
        this.ruleGeneratorModel.changeFunction = changeFunc;
        this.ruleGeneratorModel.event = evt;
        this.ruleGeneratorModel.filter = this.parseExpressionToFilter(clientRuleData.expression);
        if (this.ruleGeneratorModel.filter) {
            this.query = genQueryFromFilters([this.ruleGeneratorModel.filter]);
        }
        this.model.data.clientParams.forEach(q => {
            this.addToSourceField(q.name);
        });
        this.controlValue.dataSource = this.dataSourceFields;
        this.ruleGeneratorModel.showForm = true;
    }

    parseExpressionToFilter(expression: string): Filter {
        try {
            const logic = (jsep as any)(expression);
            const filter = this.deQuy(logic, null);
            return <any>filter;
        }
        catch (err) {
            this._notifierService.showWarning('Không thể convert logic');
            return null;
        }
    }

    deQuy(logic: any, logicParent): Filter | string {
        const type = logic.type;
        if (type == 'LogicalExpression') {
            const left = this.deQuy(logic.left, logic);
            const right = this.deQuy(logic.right, logic);

            const logicFilterLeft = (<any>left).logic;
            if (logicFilterLeft
                && logic.operator
            ) {
                const correctLogicLeft = this.correctLogic(logicFilterLeft);
                const correctLogicRoot = this.correctLogic(logic.operator);
                if (correctLogicLeft == correctLogicRoot) {
                    return {
                        logic: correctLogicRoot,
                        filters: [...(<any>left).filters, <any>right]
                    };
                }
            }
            return {
                logic: this.correctLogic(logic.operator),
                filters: [<any>left, <any>right]
            }
        }
        else if (type == 'BinaryExpression') {
            const left = this.stringfyExpression(logic.left);
            const right = this.stringfyExpression(logic.right);
            return {
                field: left,
                operator: logic.operator,
                value: JSON.stringify(right)
            }

        }
        else if (logicParent.type == 'LogicalExpression') {
            return <any>{
                field: this.stringfyExpression(logic),
                operator: '==',
                value: JSON.stringify(true)
            }
        }
        else {
            return this.stringfyExpression(logic);
        }
    }

    correctLogic(operator) {
        if (operator == '&&' || operator == '&' || (operator != null && operator.toLowerCase() == 'and')) {
            return 'and';
        }
        return 'or';
    }

    stringfyExpression(logic) {
        const type = logic.type;
        if (type == 'Literal') {
            return logic.raw;
        }
        else if (type == 'Identifier') {
            return logic.name;
        }
        else if (type == 'MemberExpression') {
            let result = '';
            let memberExpression = { ...logic };
            while (memberExpression.object) {
                result = `.${memberExpression.property.name}${result}`;
                memberExpression = memberExpression.object;
            }
            result = `${memberExpression.name}${result}`;
            return result;
        }
        else if (type == 'ConditionalExpression') {
            const condition = this.stringfyExpression(logic.test);
            return `${condition} ? ${logic.consequent.raw} : ${logic.alternate.raw}`;
        }
        else if (type == 'CallExpression') {
            let strArgument = '';
            let separator = ', ';
            for (let i = 0; i < logic.arguments.length; i++) {
                strArgument += `${this.stringfyExpression(logic.arguments[i])}, `;
            }
            strArgument = strArgument.substring(0, strArgument.length - separator.length);
            return `${logic.callee.object.name}.${logic.callee.property.name}(${strArgument})`;
        }
        else if (type == 'BinaryExpression' || type == 'LogicalExpression') {
            const left = this.stringfyExpression(logic.left);
            if (left == null || typeof left != 'string') {
                return null;
            }
            const right = this.stringfyExpression(logic.right);
            if (right == null || typeof right != 'string') {
                return null;
            }
            return `${left} ${logic.operator} ${right}`;
        }
        else if (type == 'UnaryExpression') {
            const right = this.stringfyExpression(logic.argument);
            if (right == null || typeof right != 'string') {
                return null;
            }
            return `${logic.operator}${right}`;
        }
        else {
            this._notifierService.showWarning(`Not support ${type}`);
            return null;
        }
    }

    private addToSourceField(field: string) {
        const fieldInLower = field.toLowerCase();
        if (!this.dataSourceFields.some(x => x.ten.toLowerCase() == fieldInLower)) {
            this.dataSourceFields.push({
                id: field,
                ten: field
            });
        }
    }

    _getFilter(indexResult: number[], tokenRoots: any[]) {
        if (indexResult[0] == EnumType.OPERATOR) {
            const tokens = tokenRoots.splice(indexResult[1] - 2, 3)
            let operator = tokens[2].value;
            if (this.mathOperators.some(x => x == operator)) {
                return `${tokens[0].value} ${operator} ${tokens[1].value}`;
            }
            return {
                field: tokens[0].value.toString(),
                operator,
                value: JSON.stringify(tokens[1].value.toString())
            };
        }
        else {
            const tokens = tokenRoots.splice(indexResult[1] - 3, 4);
            return {
                field: tokens[0].value.toString(),
                operator: tokens[1].value,
                value: JSON.stringify(tokens[2].value.toString())
            };
        }
    }

    handleChangeField(field) {
        if (!field) return;
        this.addToSourceField(field);
    }

    handleGeneratedRule() {
        const filter = this.query.getQuery();
        const expression = this.deQuyGenExpression(filter);

        this.ruleGeneratorModel.showForm = false;
        this.ruleGeneratorModel.data.expression = expression;
        this.ruleGeneratorModel.changeFunction(
            this.ruleGeneratorModel.control,
            this.ruleGeneratorModel.event,
            'change',
            this.ruleGeneratorModel.data,
            this.ruleGeneratorModel.parentPath
        );
    }

    deQuyGenExpression(filter: any, isRoot: boolean = true) {
        if (filter.logic) {
            const filters = [];
            filter.filters.forEach(filter => {
                filters.push(this.deQuyGenExpression(filter, false));
            });
            if (filters.length > 1) {
                let result = `${filters.join(` ${filter.logic.toLowerCase() == 'and' ? '&&' : '||'} `)}`;
                if (!isRoot) {
                    return `(${result})`;
                }
                return result;
            }
            return filters[0];
        }
        else {
            if (filter.operator == '==' && filter.value != null && (filter.value.toLowerCase() == '"true"' || filter.value.toLowerCase() == 'true')) {
                return `${filter.field}`;
            }
            return `${filter.field} ${filter.operator} ${JSON.parse(filter.value)}`;
        }
    }

    onBeforeSave() {
        // trước khi lưu
        var data = this.model.data;
        try {
            var params = [];
            for (var cp of data.clientParams) {
                params.push({ Name: cp.name, Expression: cp.value });
            }
            data.params = JSON.stringify(params);

            var rules = [];
            for (var cr of data.clientRules) {
                var r = { Expression: cr.expression, ErrorMessage: cr.errorMessage };
                if (cr['output'] != null && cr['output'] != "")
                    r["Properties"] = { output: cr['output'] };
                rules.push(r);
            }
            data.rules = JSON.stringify(rules);
        } catch { }
    }
}

